// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"552":"rules","754":"markets","794":"cases","809":"users","964":"billing"}[chunkId] || chunkId) + "-legacy." + {"8":"165ee461","12":"355530a4","125":"ad81a66a","552":"b6c0b276","673":"1de1abbf","738":"b10cd8c2","754":"3d359c7d","794":"6729dfbc","809":"673bd3b2","865":"976e3e57","964":"0f8a58fa"}[chunkId] + ".js";
};